import { PlayIcon } from '../../components/icons-library/play';
import theme from '../../style/theme';
import { useContext, Show } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';

export const PlayAndCircle = () => {
    const { viewport } = useContext(AppContext);

    return (
        <div class="play-and-circle shrink-0 rounded-half bg-black/40 relative cursor-pointer flex justify-center items-center w-32 h-32 max-mobile:w-24 max-mobile:h-24">
            <div class="translate-x-[10%]">
                <Show
                    fallback={<PlayIcon width={4.5} height={4.5} fill='white' />}
                    when={viewport.width <= theme.breakpoints.MOBILE}>
                    <PlayIcon width={3.5} height={3.5} fill='white' />
                </Show>
            </div>
        </div>
    );
};
